import script from "./MainBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBlock.vue?vue&type=script&setup=true&lang=js"

import "./MainBlock.vue?vue&type=style&index=0&id=37ad08ca&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ad08ca"]])

export default __exports__